import { useSearchPathBuilder } from '@unisporkal/search-url-builder';
import { PathUtils } from '@unisporkal/utilities';
import { useGalleryService } from 'app/hooks';
import useSearchParametersAdapter from 'app/adapters/shared/searchParameters/useSearchParametersAdapter';
import useSearchQueryAdapter from 'app/adapters/shared/searchParameters/useSearchQueryAdapter';

export default () => {
  const toSearchQuery = useSearchQueryAdapter();
  const searchPathBuilder = useSearchPathBuilder();
  const galleryService = useGalleryService();
  const searchParameters = useSearchParametersAdapter();

  return async (customSearchParameters = {}, responseFields = []) => {
    const params = toSearchQuery(searchParameters.with(customSearchParameters));

    let searchPath = searchPathBuilder.searchPath(params);
    searchPath = PathUtils.appendQueryParamsToString(searchPath, {
      responsefields: responseFields.join(','),
    });

    return galleryService.getSearch(searchPath);
  };
};
